import apiService from "./apiService";

const API_BASE = "/admin";

// --- SHIPPING COUNTRIES ---
export const getShippingCountries = async () => {
  const response = await apiService.get(`${API_BASE}/shipping-country`);
  return response.data;
};

export const getShippingCountryById = async (id) => {
  const response = await apiService.get(`${API_BASE}/shipping-country/${id}`);
  return response.data;
};

export const createShippingCountry = async (data) => {
  const response = await apiService.post(`${API_BASE}/shipping-country`, data);
  return response.data;
};

export const updateShippingCountry = async (id, data) => {
  const response = await apiService.put(
    `${API_BASE}/shipping-country/${id}`,
    data,
  );
  return response.data;
};

export const deleteShippingCountry = async (id) => {
  const response = await apiService.delete(
    `${API_BASE}/shipping-country/${id}`,
  );
  return response.data;
};

// --- SHIPPING REGIONS ---
export const getShippingRegions = async () => {
  const response = await apiService.get(`${API_BASE}/shipping-region`);
  return response.data;
};

export const getShippingRegionById = async (id) => {
  const response = await apiService.get(`${API_BASE}/shipping-region/${id}`);
  return response.data;
};

export const createShippingRegion = async (data) => {
  const response = await apiService.post(`${API_BASE}/shipping-region`, data);
  return response.data;
};

export const updateShippingRegion = async (id, data) => {
  const response = await apiService.put(
    `${API_BASE}/shipping-region/${id}`,
    data,
  );
  return response.data;
};

export const deleteShippingRegion = async (id) => {
  const response = await apiService.delete(`${API_BASE}/shipping-region/${id}`);
  return response.data;
};
